export default "__VITE_ASSET__KnP5_EmU__"